// extracted by mini-css-extract-plugin
export default {"padding":"0","default-padding":"_2nJXw","defaultPadding":"_2nJXw"};